import React from 'react';
import PropTypes from 'prop-types';
import { withPreference } from '@bingads-webui-react/preference-context';
import {
  withFullScreenLayoutNavRefresh,
} from '@bingads-webui-react/app-layout-container';
import { withGlobalErrorView } from '@bingads-webui-campaign-react/global-error-options';
import { withServerContext } from '@bingads-webui-campaign-react/server-context';
import { withFooter } from '@bingads-webui-campaign-react/content-footer-hoc';
import { withPermissions } from '@bingads-webui-react/hoc-with-permissions';
import { withStateStore } from '@bingads-webui/with-state-store';
import { isNewOnboardingVisibleStore } from '@bingads-webui-campaign-react/onboarding-toggle';
import {
  withCampaignSiteMap,
} from '@bingads-webui-campaign-react/with-site-map';

import { lazyLoad, withContexts } from './utils';
import { withPagePerfMarker } from '../contexts/with-page-perf-marker';
import { withCcJsDataContextProvider } from '../contexts/with-cc-js-data-context-provider';
import { routes as r } from './dynamic-routes';

const ChooseObjectiveWithLegacyConfig = withCcJsDataContextProvider(withFullScreenLayoutNavRefresh(withGlobalErrorView(withPagePerfMarker(lazyLoad(r.ChooseObjectiveWithLegacyConfig, c => withFooter(withContexts(withServerContext(c)))), 'Route_ChooseObjective_VNext'))));
const CampaignOnboardingV2 = withCcJsDataContextProvider(withFullScreenLayoutNavRefresh(withGlobalErrorView(withPagePerfMarker(lazyLoad(r.CampaignOnboardingV2, c => withFooter(withContexts(withServerContext(c)))), 'Route_ChooseObjectiveV2'))));

const CampaignOnboardingShellInternal = ({ permissions }) => {
  if (permissions.dynamic.DisplayPlusCampaigns) {
    return <CampaignOnboardingV2 />;
  }

  return <ChooseObjectiveWithLegacyConfig />;
};

CampaignOnboardingShellInternal.propTypes = {
  permissions: PropTypes.shape({
    dynamic: PropTypes.shape({
      DisplayPlusCampaigns: PropTypes.bool,
    }),
  }).isRequired,
};

export const CampaignOnboardingShell = withCampaignSiteMap(withStateStore(
  withPreference(withPermissions(CampaignOnboardingShellInternal)),
  isNewOnboardingVisibleStore,
  store => ({
    isNewOnboardingVisible: store.state.isNewOnboardingVisible,
  })
));
